import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchQuery: "",
  pageTitle: ["Dashboard"],
  searchEnabled: false,
  searchOnEnter: false,
  navLink: [''],
  placeHolder: "Search"
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },
    clearSearchQuery(state) {
      state.searchQuery = "";
    },
    setPageTitle(state, action) {
      state.pageTitle = action.payload;
    },
    setSearchEnabled(state, action) {
      state.searchEnabled = action.payload;
    },
    setSearchOnEnter(state, action) {
      state.searchOnEnter = action.payload;
    },
    setNavLink(state, action) {
      state.navLink = action.payload;
    },
    setPlaceHolder(state, action) {
      state.placeHolder = action.payload
    }
  },
});

export const {
  setSearchQuery,
  clearSearchQuery,
  setPageTitle,
  setSearchEnabled,
  setSearchOnEnter,
  setNavLink,
  setPlaceHolder
} = uiSlice.actions;

export default uiSlice.reducer;
